import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { CommonPlatformService, Platform, CommonUtil } from 'psd-common';

@Component({
    selector: 'central-login-error',
    templateUrl: 'central-login-error.component.html'
})
export class CentralLoginErrorComponent implements OnInit {
    public errorMessage: string;
    public platformPrefix: string;
    public currentPlatform: Platform;
    private error: string;

    constructor(@Inject(DOCUMENT) private document: Document,
                private renderer: Renderer2,
                private translateService: TranslateService,
                private platformService: CommonPlatformService,
                private router: Router,
                private route: ActivatedRoute) {}

    ngOnInit() {
        this.renderer.addClass(this.document.body, 'login');
        this.route.queryParams.subscribe(_params => {
            this.platformPrefix = _params.platform;
            this.error = _params.error != null ? _params.error : 'default';

            if (this.platformPrefix) {
                this.platformService.getExternalPlatformDetails(this.platformPrefix).subscribe(_platform => {
                    this.currentPlatform = _platform;
                });
            }

            let errorMessageKey = 'central-login.error.' + this.error;
            this.errorMessage = this.translateService.instant(errorMessageKey);
        });
    }

    goToLogin() {
        this.router.navigate(['central-login/login'], { queryParams: { platform: this.platformPrefix } });
    }
}
